module.exports = __webpack_public_path__ + "img/data_generate.1185b90f.png";